import React from 'react';
import { History } from 'history';
import { Input, InputDate, InputFile, InputMoney, InputMultiline, InputSelect, Layout, InputPicklist } from '../../components';
import BaseEdit from '../base/base-edit.component'; 
import Model from './transaction-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import TransactiontypePicklist from '../transactiontype/transactiontype-picklist.component';
import TransactiondetailList from '../transactiondetail/transactiondetail-list.component';
import TransactionamountList from '../transactionamount/transactionamount-list.component';
import TransactionpaymentList from '../transactionpayment/transactionpayment-list.component';
import JournalList from '../journal/journal-list.component';
import PersonalinfoPicklist from '../personalinfo/personalinfo-picklist.component';
import DivisionPicklist from '../division/division-picklist.component';
import SchedulePicklist from '../schedule/schedule-picklist.component';
import EventCopy from '../event/event-copy.component';
import AppService from '../../services/app.service';


interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    transactiontypeType?: string;
    actions?: any;
    readonlyFields?: any;
    disableFields?: any;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
    datasetTransactiondetail: Array<any>;
    datarowEvent: any;
    saveOrder: number;
    save: boolean;
}

export default class TransactionEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
            datasetTransactiondetail: [],
            datarowEvent: null,
            saveOrder: -1,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});    
    }

    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }

    private onLoadTransactiontype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'transactiontype': data?.id, 'transactiontypeCaption': data?.name || ''  }  });
    }
    
    private onLoadCustomer = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'customer': data?.id, 'customerCaption': data?.name || ''  }  });
    }
    
    private onLoadEmployee = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'employee': data?.id, 'employeeCaption': data?.name || ''  }  });
    }
    
    private onLoadVendor = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'vendor': data?.id, 'vendorCaption': data?.name || ''  }  });
    }
    
    private onLoadDivision = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'division': data?.id, 'divisionCaption': data?.name || ''  }  });
    }
    
    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'schedule': data?.id, 'scheduleCaption': data?.name || ''  }  });
    }
    
    private onLoadTransactionpayment = (data: any) => {
        if (this.props.actions?.transactionpayment?.includes('upload')) 
            this.props.history.push('/transactionpayment', {id: data.id});
    }
    
    private onLoadAllTransactiondetail = async(data: any) => {
        if (this.state.datarow.id > 0 && data.total !== this.state.datarow.totaldetail) 
            this.setState({ datarow: {...this.state.datarow, 'totaldetail': data.total, 'total': this.state.datarow.totalamount + data.total, 'totalremaining': (this.state.datarow.totalamount + data.total) - this.state.datarow.totalpayment}, save: true});
        this.setState({ datasetTransactiondetail: data.data});
    }

    private onLoadAllTransactionamount = async(data: any) => {
        if (this.state.datarow.id > 0 && data.total !== this.state.datarow.totalamount) 
            this.setState({ datarow: {...this.state.datarow, 'totalamount': data.total, 'total': this.state.datarow.totaldetail + data.total, 'totalremaining': (this.state.datarow.totaldetail + data.total) - this.state.datarow.totalpayment}, save: true});
    }

    private onLoadAllTransactionpayment = async(data: any) => {
        if (this.state.datarow.id > 0 && (data.total !== this.state.datarow.totalpayment || data.status !== this.state.datarow.statuspayment))
            this.setState({ datarow: {...this.state.datarow, 'totalpayment': data.total, 'totalremaining': this.state.datarow.total - data.total, 'statuspayment': data.status}, save: true});
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }

    private onErrorEvent = (data: any) => {
        if (data) this.setState({ errors: {transactiondetail: 'Product Event - ' + data?.[Object.keys(data).toString()]}})
    }

    private saveEvent(saveOrder: number) {
        var d = this.state.datasetTransactiondetail?.[saveOrder];
        d = d && !d.event ? {id: d.productEvent, astemplate: 'no', name: d.name || d.productCaption, startdate: d.startdate, customer: this.state.datarow.customer, transactiondetail: d.id} : {id: 0} 
        this.setState({ datarowEvent: {...this.state.datarowEvent, ...d}, saveOrder: saveOrder})
    }

    private onSaveEvent = (data: any) => {
        this.state.datasetTransactiondetail[this.state.saveOrder].event = data.id;
        this.saveEvent(this.state.saveOrder - 1);
    }
    
    private onSave = async (data: any) => {
        this.setState({save: false});
        if (this.state.datarow.status === 'approved') 
            this.saveEvent(this.state.datasetTransactiondetail?.length - 1);
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
        
    }    

    render() {
        return (
            //editable..
            <>
            <BaseEdit history={this.props.history} caption={this.props.caption} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} save={this.state.save} onLoad={this.onLoad} onError={this.onError} onSave={this.onSave} disableAutoBack={this.state.save} disableCard>              
                               
                <Layout history={this.props.history} content={[
                    {caption: 'Details', hide: this.props.disableFields?.includes('transaction'), child: 
                    <>
                        <InputSelect name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('status')} />
                        <Input name='name' label='Number' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} />
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} />
                        {!this.props.disableFields?.includes('owner') && AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                        </InputPicklist> 
                        }
                        {!this.props.disableFields?.includes('transactionType') &&
                        <InputPicklist name='transactiontype' label='Transaction Type' value={this.state.datarow.transactiontype} caption={this.state.datarow.transactiontypeCaption} error={this.state.errors?.transactiontype} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <TransactiontypePicklist transactiontypeType={this.props.transactiontypeType} currentId={this.state.datarow.transactiontype} onLoad={this.onLoadTransactiontype}/>
                        </InputPicklist>
                        }
                        <InputDate name='transactiondate' label='Date' value={this.state.datarow.transactiondate} error={this.state.errors?.transactiondate} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} />
                        {!this.props.disableFields?.includes('image') &&
                        <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} />
                        }
                        {!this.props.disableFields?.includes('customer') &&
                        <InputPicklist name='customer' label='Customer' value={this.state.datarow.customer} caption={this.state.datarow.customerCaption} clearValue={this.onLoadCustomer} error={this.state.errors?.customer} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <PersonalinfoPicklist personalinfotypeType='customer' currentId={this.state.datarow.customer} onLoad={this.onLoadCustomer}/>
                        </InputPicklist>
                        }
                        {!this.props.disableFields?.includes('vendor') &&
                        <InputPicklist name='vendor' label='Vendor' value={this.state.datarow.vendor} caption={this.state.datarow.vendorCaption} clearValue={this.onLoadVendor} error={this.state.errors?.vendor} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <PersonalinfoPicklist personalinfotypeType='vendor' currentId={this.state.datarow.vendor} onLoad={this.onLoadVendor}/>
                        </InputPicklist>
                        }
                        {!this.props.disableFields?.includes('employee') &&
                        <InputPicklist name='employee' label='Employee' value={this.state.datarow.employee} caption={this.state.datarow.employeeCaption} clearValue={this.onLoadEmployee} error={this.state.errors?.employee} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <PersonalinfoPicklist personalinfotypeType='employee' currentId={this.state.datarow.employee} onLoad={this.onLoadEmployee}/>
                        </InputPicklist>
                        }
                        {!this.props.disableFields?.includes('division') &&
                        <InputPicklist name='division' label='Division' value={this.state.datarow.division} caption={this.state.datarow.divisionCaption} clearValue={this.onLoadDivision} error={this.state.errors?.divisionCaption} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <DivisionPicklist currentId={this.state.datarow.division} onLoad={this.onLoadDivision}/>
                        </InputPicklist>
                        }
                        {!this.props.disableFields?.includes('schedule') &&
                        <InputPicklist name='schedule' label='Schedule' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} readOnly={this.props.readonlyFields?.includes('transaction')} >
                            <SchedulePicklist currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule}/>
                        </InputPicklist>
                        }
                        </>
                    },

                    {caption: 'Orders', hide: this.props.disableFields?.includes('transactiondetail','transactionamount'), child: 
                    this.state.datarow.id > 0 && this.props.history &&
                    <>
                        {!this.props.disableFields?.includes('transactiondetail') &&
                            <TransactiondetailList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} onLoadAll={this.onLoadAllTransactiondetail} actions={this.props.actions?.transactiondetail || (this.props.readonlyFields?.includes('transactiondetail')? ['view'] : ['...'])} disableBackButton disableCard/> 
                        }
                        {!this.props.disableFields?.includes('transactionamount') &&
                            <>
                            <InputMoney name='totaldetail' label='Sub Total' value={this.state.datarow.totaldetail} readOnly/>
                            <TransactionamountList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} onLoadAll={this.onLoadAllTransactionamount} actions={this.props.actions?.transactionamount || (this.props.readonlyFields?.includes('transactionamount')? ['view'] : ['...'])} disableBackButton disableCard/> 
                            </>
                        }
                        {!this.props.disableFields?.includes('transactiondetail','transactionamount') &&
                            <InputMoney name='total' label='Total' value={this.state.datarow.total} size='medium' readOnly/>
                        }
                    </>
                    },

                    {caption:'Payments', hide: this.props.disableFields?.includes('transactionpayment'), child:
                    this.state.datarow.id > 0 && 
                        <>
                        <InputSelect name='statuspayment' label='' value={this.state.datarow.statuspayment} options={Model.optionStatuspayment} readOnly />
                        <TransactionpaymentList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} onLoad={this.onLoadTransactionpayment} onLoadAll={this.onLoadAllTransactionpayment} actions={this.props.actions?.transactionpayment || (this.props.readonlyFields?.includes('transactionpayment')? ['view'] : ['...'])} disableBackButton disableCard/> 
                        <InputMoney name='totalpayment' label='Total Payment' value={this.state.datarow.totalpayment} readOnly/>
                        {this.state.datarow.statuspayment !== 'paid' &&
                            <InputMoney name='totalremaining' label='Remaining' value={this.state.datarow.totalremaining} readOnly/>
                        }
                        </>
                    },
 
                    {caption:'Journals', hide: this.props.disableFields?.includes('journal'), child:
                    this.state.datarow.id > 0 &&
                        <JournalList history={this.props.history} root={this.props.root} transactionId={this.state.datarow.id} actions={this.props.actions?.journal || (this.props.readonlyFields?.includes('journal')? ['view'] : ['...'])} disableBackButton disableCard/> 
                    },

                   ]}
                    
                />

            </BaseEdit>
            
            {this.state.datarowEvent?.id &&
            <EventCopy history={this.props.history} id={this.state.datarowEvent.id} datarow={this.state.datarowEvent} onError={this.onErrorEvent} save onSave={this.onSaveEvent} disableView/> 
            }
            </>
        );
    }
}